module.exports = __webpack_public_path__ + "img/menu-hulianwang.d2fc8aec.svg";